/*
* Javascript for AJAX Guests fields.
*/
Guests_search = {
	init : function()
	{
		// Check if Sleeps Min select search elements are on page.
		//if( jQuery( '[name="sleeps_min"]' ).size() == 0 )
		if( jQuery( '[data-oc-id="sleeps-min-ajax"]' ).size() == 0 )
		{
			return false;
		}
		
		// Get data.
		var url = 'library/property/services/property-list.php';
		var config = new Object();
		config.cache = true;
		//config.sort = 'alphabetical';
		//options.abn = sh__site_object.property_options.client.abn;
		//options.license_1 = sh__site_object.property_options.client.sh_licence_1;
		//options.property_type = 'holiday';
		
		// Assemble options for property list.
		var options = {};
		options.order = 'asc';
		options.sort = 'alphabetical';
		options.properties_per_page = 0; // We want the full list for the selects.
		var data_options = {};
		data_options.action = 'oc_property_list';
		data_options.include_html = false;
		data_options.options = options;
		
		// Assemble options for Property Service.
		var ps_config = {};
		ps_config.queue_id = 'full-property-list';
		ps_config.client = 'guests-search-field';
		ps_config.end_point = 'getProperties';
		
		// Calls.
		//Property_service_oncloud.get_data(url, config);
		//Property_service_oncloud.get_aa_data('oc_property_list',data_options);
		Property_service.get_data(ps_config);
		
		// Respond to AJAX property list data received.
		jQuery(document).on('oc_property_service_oc_data_retrieval',function(event,response){
			// Retrieve the required parameters.
			let information = response.data.information;
			
			// Set UI elements.
			//Guests_search.init_ui(information);
		});
		
		jQuery(document).on('oc_property_service_oc_data_retrieval_aa',function(event,response){
			// Retrieve the required parameters.
			let information = response.data.property_list.information;
			
			// Set UI elements.
			//Guests_search.init_ui(information);
		});
		
		// Respond to AJAX property list data received.
		jQuery(document).on('oc_property_list_external_update',function(event,pm_options){
		});
		
		// Respond to Data retrieval from PROPERTY SERVICE.
		jQuery(document).on('property_service_data_retrieval',function(event,response){
			// Set UI elements.
			Guests_search.init_ui(response.data.propertyInfo);
		});
	}
	,
	init_ui: function(pm_data = {})
	{
		// Get the Guests information.
		let guests = pm_data.guests;
		let min = guests.adults.min;
		let max = parseInt(guests.adults.max);
		
		// Get current URL URI instance.
		var uri = new URI();
		
		// Get query string.
		var query = uri.search(true);
		// TODO: Look for AJAX Setting
		
		//let sleeps_min = parseInt(query.sleeps_min);
		let sleeps_min = parseInt(jQuery('[name="sleeps_min"]').parent('.form-group').attr('data-current'));
		
		// Turn off loading text.
		jQuery('select[name="sleeps_min"] option[value=""]').text('Guests');
		
		// Use the Guests information to fill in the Select box.
		for(let i = 1; i <= max; i++)
		{
			let selected = (sleeps_min == i) ? ' selected="selected"' : '';
			
			jQuery('[name="sleeps_min"]').append('<option value="' + i + '"' + selected + '>' + i + '+</option>');
		}
		
		jQuery('[name="sleeps_min"]').on('change', function(event){
			var guests_min_field = jQuery(this);
			
			// Update tracking on current selection.
			guests_min_field.parent('.form-group').attr('data-current',guests_min_field.val());
		});
	}
}

jQuery(document).ready(function(jQuery){
	Guests_search.init();
});